/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_Privacy_PolicyInputs */



/**
* | output |
* | --- |
* | "Privacy Policy" |
*
* @param {Footer_Privacy_PolicyInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const footer_privacy_policy = /** @type {((inputs?: Footer_Privacy_PolicyInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_Privacy_PolicyInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Datenschutz")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Confidentialité")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("隐私政策")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("隱私權政策")
	if (locale === "ko") return /** @type {LocalizedString} */ ("개인정보 처리방침")
	return /** @type {LocalizedString} */ ("Privacy Policy")
});